import LinkToDocusaurus from '../LinkToDocusaurus'
import { coverageHeatmap } from '../../docs-routes'

const LinkToCoverageHeatmapDoc = () =>
  <LinkToDocusaurus path={coverageHeatmap}>
    Learn more about Coverage Heatmap
  </LinkToDocusaurus>

export default LinkToCoverageHeatmapDoc
